export default {
    // Dutch
    nl: {
        languages: {
            nl: 'Nederlands',
            en: 'Engels',
            de: 'Duits',
            fr: 'Frans',
            it: 'Italiaans',
            es: 'Spaans',
            pt: 'Portugees',
        },
        days: {
            day1: 'maandag',
            day2: 'dinsdag',
            day3: 'woensdag',
            day4: 'donderdag',
            day5: 'vrijdag',
            day6: 'zaterdag',
            day7: 'zondag',
        },
        months: {
            month1: 'januari',
            month2: 'februari',
            month3: 'maart',
            month4: 'april',
            month5: 'mei',
            month6: 'juni',
            month7: 'juli',
            month8: 'augustus',
            month9: 'september',
            month10: 'oktober',
            month11: 'november',
            month12: 'december',
        },
        navigation: {
            next: 'Volgende',
            prev: 'Stap terug',
            quit: 'Stoppen en opnieuw beginnen',
            guide: 'Loop je tegen een probleem aan? Meld je dan bij de receptie of bel {phone_number} als de receptie is gesloten.',
            pagination: {
                next: 'Volgende pagina',
                prev: 'Vorige pagina',
            },
            reset: 'Terug naar startscherm',
        },
        flows: {
            book: 'Nieuwe reservering plaatsen',
            checkIn: 'Bestaande reservering ophalen',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Boeken',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Boeking bevestigen',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Boek een kampeer- of camperplaats',
            par1: 'Je kunt hier een kampeer- of camperplaats boeken en direct inchecken. Betalen kan met mobiel bankieren of op een later tijdstip bij de receptie.',
            par2: 'Uitgebreide informatie over onze kampeer- en camper plaatsen vind je bij de receptie of check {website_url}',
            // Legacy: 'intro-booking'
            start: 'Start boeking',
            // Legacy: 'intro-text-2'
            subtitle: 'Accommodatie boeken',
            par3: 'Boeken van accommodaties kan uitsluitend bij de receptie tijdens openingstijden of online via {website_url}.',
        },
        travelGroup: {
            title: 'Kies je reisgezelschap',
        },
        stayDuration: {
            title: 'Verblijfsduur',
            nights: 'Aantal nachten',
            arrival: 'Aankomstdatum',
            departure: 'Vertrekdatum',
            availability: 'Beschikbaar',
            checking: 'Bezig met beschikbaarheid controleren',
            available: 'Voldoende plekken beschikbaar.',
            unavailable: 'Helaas, volgeboekt.<br/>Vraag bij de receptie naar de mogelijkheden.',
        },
        pickAccommodation: {
            title: 'Kies je accommodatie',
            until: 'tot',
        },
        pets: {
            title: 'Huisdieren',
            description: 'Honden zijn welkom. Ze moeten binnen ons terrein altijd aangelijnd zijn en er geldt overal een opruimplicht.',
            type: 'Huisdieren',
        },
        pickAccommodationObject: {
            title: 'Kies uw locatie',
            selected: 'Geselecteerde locatie',
            selectedNone: 'Er is geen locatie geselecteerd',
            noContent: 'Helaas is de laatst beschikbare accommodatie nét gereserveerd, kies a.u.b. een andere accommodatie.',
        },
        extras: {
            title: 'Extra\'s',
        },
        receipt: {
            title: 'Boekingsoverzicht',
            stayCost: 'Verblijfskosten',
            stayTime: 'Verblijfsduur {nights} nachten',
            arrival: 'Aankomstdatum {date} na {time}',
            departure: 'Vertrekdatum {date} voor {time}',
            calculating: 'Bezig met de prijs berekenen',
            invalid: 'Deze accommodatie kan helaas niet geboekt worden. Ga naar de receptie voor meer informatie.',
        },
        personalDetails: {
            title: 'Persoonsgegevens',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement niet beschikbaar',
                body: 'Het gekozen arrangement is niet beschikbaar.',
            },
        },
        receiptConfirm: {
            title: 'Controle gegevens',
            total: 'Totaalbedrag',
            licensePlate: 'Kenteken voertuig',
            pinMessage: 'Betalen kan direct via de pinterminal.',
        },
        pin: {
            title: 'Pinnen',
            description: {
                par1: 'Binnen enkele seconden kunt u uw betaling op de betaalautomaat voldoen met uw pinpas',
                par2: 'U heeft ongeveer 30 seconden om de betaling te voldoen, lukt dit niet?',
                par3: 'Wij versturen u nog altijd een betaallink per mail, zodat u alsnog de betaling kan voldoen',
                extra: '',
            },
            amountDue: 'Openstaand bedrag {due}',
            retry: 'Klik hier om de betaling opnieuw te starten',
            failed: 'De betaling is helaas niet gelukt',
            paid: 'U ontvangt een bevestiging via de e-mail',
        },
        thanks: {
            description1: `
                <h2>Boeking succesvol afgerond</h2>
                <p>De boeking is afgerond en je bent ingechecked op locatie <strong class="location">{accommodation_name}{location_name}</strong>. Je ontvangt binnen enkele minuten een bevestiging per mail.</p>
            `,
            description2: `
                <p>Betaal voor {payment_due_date} bij de receptie of met mobiel bankieren.</p>
                <p>Je ontvangt binnen enkele minuten een bevestiging per mail met betaallink. Je kunt ook betalen op de receptie.</p>
            `,
            description3: `<h1 class="xl">Jouw vakantie op {park_name} is begonnen!</h1>`,
            bookingFailed: 'Het aanmaken van een boeking is mislukt. Ga naar de receptie voor meer informatie.',
            finish: 'Terug naar startscherm',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Betalen lukt nu niet',
                body: 'Op dit moment kan de betaling niet worden gestart. U ontvangt binnenkort een e-mail met een betaallink.',
            },
        },
        popupResetWizard: {
            title: 'Hallo, ben je er nog?',
            description: 'Je hebt deze zuil 5 minuten niet gebruikt. Over 30 seconden breken we je boeking af. Maak een keuze:',
            continue: 'Verder met boeken',
            restart: 'Afbreken, naar startscherm',
            close: 'Sluiten',
        },
        popupErrorMessage: {
            title: 'Oeps, er is iets misgegaan',
            continue: 'Ik snap het',
            close: 'Sluiten',
        },
        timeTable: {
            disabled: {
                title: 'Welcome to {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Voer je reserveringsnummer in',
            input: {
                label: 'Reserveringsnummer',
                placeholder: 'Bijv. 123456789',
            },
            check: 'Aanmelden',
            failed: {
                unknownReservationNumber: 'Er bestaat geen reservering met het ingevoerde nummer',
                alreadyArrived: 'Deze reservering is al aangemeld',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Aanhef',
        book__form_field_firstname: 'Voornaam',
        book__form_field_infix: 'Tussenvoegsel',
        book__form_field_surname: 'Achternaam',
        book__form_field_organisation: 'Organisatie',
        book__form_field_email: 'E-mailadres',
        book__form_field_telephone: 'Telefoonnummer',
        book__form_field_mobile: 'Mobiel nummer',
        book__form_field_phone: 'Telefoonnummer',
        book__form_field_country: 'Land',
        book__form_field_zipcode: 'Postcode',
        book__form_field_house_number: 'Huisnummer',
        book__form_field_house_number_suffix: 'Toevoeging',
        book__form_field_street: 'Straat',
        book__form_field_place: 'Plaats',
        book__form_field_birthdate: 'Geboortedatum',
        book__form_field_birthplace: 'Geboorteplaats',
        book__form_field_nationality: 'Nationaliteit',
        book__form_field_passport_number: 'Paspoort nummer',
        book__form_field_license_plate: 'Kenteken',
        book__form_field_license_plate2: 'Kenteken 2',
        book__tommy_salution_malefemale: 'De heer / mevrouw',
        book__tommy_salution_male: 'De heer',
        book__tommy_salution_female: 'Mevrouw',
        book__tommy_salution_family: 'Familie',
        book__form_validation_error_required: '{field} moet ingevuld zijn',
        book__form_validation_error_required_simple: 'Dit veld moet ingevuld zijn',
        book__form_validation_error_required_email: 'Sorry, het ingevoerde e-mailadres is ongeldig',
        book__form_validation_error_required_birthdate: 'Sorry, de ingevoerde geboortedatum is ongeldig',
    },

    // English
    en: {
        languages: {
            nl: 'Dutch',
            en: 'English',
            de: 'German',
            fr: 'French',
            it: 'Italian',
            es: 'Spanish',
            pt: 'Portuguese',
        },
        days: {
            day1: 'Monday',
            day2: 'Tuesday',
            day3: 'Wednesday',
            day4: 'Thursday',
            day5: 'Friday',
            day6: 'Saturday',
            day7: 'Sunday',
        },
        months: {
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
        },
        navigation: {
            next: 'Next',
            prev: 'Previous step',
            quit: 'Stop and start again',
            guide: 'Do you have a problem? Then report it to reception or call {phone_number} when reception is closed.',
            pagination: {
                next: 'Next page',
                prev: 'Previous page',
            },
            reset: 'Back to home',
        },
        flows: {
            book: 'Place new reservation',
            checkIn: 'Retrieve existing reservation',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Book',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Confirm booking',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Book a camping- or motorhome pitch',
            par1: 'You can book a camping- or motorhome pitch here and check in directly. You can pay with mobile banking or at a later time at the reception.',
            par2: 'Comprehensive information about our camping- and camper pitches can be found at the reception or check {website_url}',
            // Legacy: 'intro-booking'
            start: 'Start booking',
            // Legacy: 'intro-text-2'
            subtitle: 'Booking accommodation',
            par3: 'Booking accommodation is only possible at the reception during opening hours or online at {website_url}.',
        },
        travelGroup: {
            title: 'Choose your travel group',
        },
        stayDuration: {
            title: 'Length of stay',
            nights: 'Number of nights',
            arrival: 'Arrival date',
            departure: 'Departure date',
            availability: 'Available at',
            checking: 'Checking availability',
            available: 'Plenty of spots available.',
            unavailable: 'Unfortunately, we\'re fully booked.<br/>Please ask at reception for possible options.',
        },
        pickAccommodation: {
            title: 'Choose your accommodation',
            until: 'until',
        },
        pets: {
            title: 'Pets',
            description: 'Dogs are welcome. They must always be kept on a leash while on the premises, and cleaning up after them is mandatory.',
            type: 'Pets',
        },
        pickAccommodationObject: {
            title: 'Choose your location',
            selected: 'Selected location',
            selectedNone: 'No location has been selected',
            noContent: 'Unfortunately, the last available accommodation has just been reserved. Please choose another accommodation.',
        },
        extras: {
            title: 'Extras',
        },
        receipt: {
            title: 'Booking overview',
            stayCost: 'Accommodation costs',
            stayTime: 'Length of stay {nights} nights',
            arrival: 'Arrival date {date} after {time}',
            departure: 'Departure date {date} before {time}',
            calculating: 'Calculating the price',
            invalid: 'Unfortunately, this accommodation cannot be booked. Please go to the reception desk for more information.',
        },
        personalDetails: {
            title: 'Personal information',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement unavailable',
                body: 'The chosen arrangement is not available.',
            },
        },
        receiptConfirm: {
            title: 'Control data',
            total: 'Total amount',
            licensePlate: 'Vehicle registration number',
            pinMessage: 'You can pay directly via the pinterminal.',
        },
        pin: {
            title: 'Pay',
            description: {
                par1: 'Within seconds you can make your payment at the POS terminal with your debit card.',
                par2: 'You have approximately 30 seconds to complete the payment. If this does not work,',
                par3: 'We still send you a payment link by email, so that you can still make the payment.',
                extra: '',
            },
            amountDue: 'Amount outstanding {due}',
            retry: 'Click here to restart the payment',
            failed: 'Unfortunately the payment was not successful',
            paid: 'You will receive a confirmation by e-mail',
        },
        thanks: {
            description1: `
                <h2>Booking successfully completed</h2>
                <p>The booking has been completed and you have checked in at location <strong class="location">{accommodation_name}{location_name}</strong>. You will receive a confirmation email within a few minutes.</p>
            `,
            description2: `
                <p>Pay by {payment_due_date} at the reception desk or via mobile banking.</p>
                <p>You will receive a confirmation email with a payment link within a few minutes. You can also pay at the reception desk.</p>
            `,
            description3: `<h1 class="xl">Your vacation at {park_name} has begun!</h1>`,
            bookingFailed: 'The booking failed. Please go to the reception desk for more information.',
            finish: 'Back to home',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Payment unavailable right now',
                body: 'Payment cannot be started at this moment. You will shortly receive an email with a payment link.',
            },
        },
        popupResetWizard: {
            title: 'Hello, are you still there?',
            description: 'You haven\'t used this terminal for 5 minutes. We\'ll cancel your booking in 30 seconds. Make a choice:',
            continue: 'Continue with booking',
            restart: 'Return to start screen',
            close: 'Close',
        },
        popupErrorMessage: {
            title: 'Oops, something went wrong',
            continue: 'I understand',
            close: 'Close',
        },
        timeTable: {
            disabled: {
                title: 'Welcome to {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Enter your reservation number',
            input: {
                label: 'Reservation number',
                placeholder: 'E.g. 123456789',
            },
            check: 'Sign up',
            failed: {
                unknownReservationNumber: 'There is no reservation with the number entered',
                alreadyArrived: 'This reservation has already been registered',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Salution',
        book__form_field_firstname: 'First name',
        book__form_field_infix: 'Infix',
        book__form_field_surname: 'Surname',
        book__form_field_organisation: 'Organisation',
        book__form_field_email: 'Email',
        book__form_field_telephone: 'Telephone',
        book__form_field_mobile: 'Mobile',
        book__form_field_phone: 'Phone number',
        book__form_field_country: 'Country',
        book__form_field_zipcode: 'Zipcode',
        book__form_field_house_number: 'Housenumber',
        book__form_field_house_number_suffix: 'Addition',
        book__form_field_street: 'Street',
        book__form_field_place: 'Place',
        book__form_field_birthdate: 'Date of birth',
        book__form_field_birthplace: 'Place of birth',
        book__form_field_nationality: 'Nationality',
        book__form_field_passport_number: 'Passport number',
        book__form_field_license_plate: 'License plate',
        book__form_field_license_plate2: 'License plate 2',
        book__tommy_salution_malefemale: 'Mr./Ms.',
        book__tommy_salution_male: 'Mr.',
        book__tommy_salution_female: 'Ms.',
        book__tommy_salution_family: 'Family',
        book__form_validation_error_required: '{field} must be filled in',
        book__form_validation_error_required_simple: 'This field must be filled in',
        book__form_validation_error_required_email: 'Sorry, the entered email address is invalid',
        book__form_validation_error_required_birthdate: 'Sorry, the date of birth entered is invalid',
    },

    // German
    de: {
        languages: {
            nl: 'Niederländisch',
            en: 'Englisch',
            de: 'Deutsch',
            fr: 'Französisch',
            it: 'Italienisch',
            es: 'Spanisch',
            pt: 'Portugiesisch',
        },
        days: {
            day1: 'Montag',
            day2: 'Dienstag',
            day3: 'Mittwoch',
            day4: 'Donnerstag',
            day5: 'Freitag',
            day6: 'Samstag',
            day7: 'Sonntag',
        },
        months: {
            month1: 'Januar',
            month2: 'Februar',
            month3: 'März',
            month4: 'April',
            month5: 'Mai',
            month6: 'Juni',
            month7: 'Juli',
            month8: 'August',
            month9: 'September',
            month10: 'Oktober',
            month11: 'November',
            month12: 'Dezember',
        },
        navigation: {
            next: 'Nächste',
            prev: 'zurück',
            quit: 'Anhalten und neu starten',
            guide: 'Haben Sie ein Problem? Dann melden Sie sich bitte an der Rezeption oder rufen Sie {phone_number} an, wenn die Rezeption geschlossen ist.',
            pagination: {
                next: 'Nächste Seite',
                prev: 'Vorherige Seite',
            },
            reset: 'Zurück zum Startbildschirm',
        },
        flows: {
            book: 'Neue Reservierung vornehmen',
            checkIn: 'Vorhandene Reservierung abrufen',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Buchen',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Buchung bestätigen',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Campingplatz oder Wohnmobilstellplatz buchen',
            par1: 'Sie können hier einen Camping- oder Wohnmobilstellplatz buchen und direkt einchecken. Sie können mit Mobile Banking oder zu einem späteren Zeitpunkt an der Rezeption bezahlen.',
            par2: 'Umfassende Informationen über unsere Camping- und Wohnmobilstellplätze finden Sie an der Rezeption oder unter {website_url}',
            // Legacy: 'intro-booking'
            start: 'Buchung beginnen',
            // Legacy: 'intro-text-2'
            subtitle: 'Unterkunft buchen',
            par3: 'Die Buchung einer Unterkunft ist nur an der Rezeption während der Öffnungszeiten oder online unter {website_url} möglich.',
        },
        travelGroup: {
            title: 'Wähle deine Reisegruppe',
        },
        stayDuration: {
            title: 'Dauer des Aufenthalts',
            nights: 'Anzahl der Nächte',
            arrival: 'Anreisedatum',
            departure: 'Abreisedatum',
            availability: 'Verfügbar unter',
            checking: 'Verfügbarkeit wird überprüft',
            available: 'Ausreichend Plätze verfügbar.',
            unavailable: 'Leider ausgebucht.<br/>Frag bitte an der Rezeption nach freien Plätzen.',
        },
        pickAccommodation: {
            title: 'Wähle deinen Stellplatztyp',
            until: 'bis',
        },
        pets: {
            title: 'Haustiere',
            description: 'Hunde sind willkommen. Bitte halte deinen Hund auf dem gesamten Gelände an der Leine und beseitige seine Hinterlassenschaften.',
            type: 'Haustiere',
        },
        pickAccommodationObject: {
            title: 'Wählen Sie Ihren Standort',
            selected: 'Ausgewählter Standort',
            selectedNone: 'Es wurde noch kein Ort ausgewählt',
            noContent: 'Leider ist die letzte verfügbare Unterkunft gerade reserviert worden. Bitte wählen Sie eine andere Unterkunft.',
        },
        extras: {
            title: 'Extras',
        },
        receipt: {
            title: 'Buchungsübersicht',
            stayCost: 'Kosten für Unterkunft und Verpflegung',
            stayTime: 'Aufenthaltsdauer {nights} Nächte',
            arrival: 'Ankunftsdatum {date} nach {time}',
            departure: 'Abreisedatum {date} vor {time}',
            calculating: 'Berechnung des Preises läuft',
            invalid: 'Diese Unterkunft kann leider nicht gebucht werden. Weitere Informationen erhalten Sie an der Rezeption.',
        },
        personalDetails: {
            title: 'Persönliche Daten',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement nicht verfügbar',
                body: 'Das gewählte Arrangement ist nicht verfügbar.',
            },
        },
        receiptConfirm: {
            title: 'Bitte prüfen Sie Ihre Buchung',
            total: 'Gesamtbetrag',
            licensePlate: 'Fahrzeug-Kennzeichen',
            pinMessage: 'Bezahlen können Sie direkt über das Pinterminal.',
        },
        pin: {
            title: 'Zahlen',
            description: {
                par1: 'Innerhalb von Sekunden können Sie Ihre Zahlung am Zahlungsterminal mit Ihrer Debitkarte vornehmen.',
                par2: 'Sie haben etwa 30 Sekunden Zeit, um die Zahlung durchzuführen. Ist dies nicht möglich?',
                par3: 'Wir senden Ihnen nach wie vor einen Zahlungslink per E-Mail zu, so dass Sie die Zahlung noch vornehmen können.',
                extra: '',
            },
            amountDue: 'Ausstehender Betrag {due}',
            retry: 'Klicken Sie hier, um die Zahlung erneut zu starten',
            failed: 'Leider war die Zahlung nicht erfolgreich',
            paid: 'Sie erhalten eine Bestätigung per E-Mail',
        },
        thanks: {
            description1: `
                <h2>Buchung erfolgreich abgeschlossen</h2>
                <p>Die Buchung ist abgeschlossen und Sie sind am Standort <strong class="location">{accommodation_name}{location_name}</strong> eingecheckt. Sie erhalten innerhalb weniger Minuten eine Bestätigung per E-Mail.</p>
            `,
            description2: `
                <p>Bezahlen Sie bis zum {payment_due_date} an der Rezeption oder per Mobile Banking.</p>
                <p>Sie erhalten innerhalb weniger Minuten eine Bestätigung per E-Mail mit einem Zahlungslink. Sie können auch an der Rezeption bezahlen.</p>
            `,
            description3: `<h1 class="xl">Ihr Urlaub im {park_name} hat begonnen!</h1>`,
            bookingFailed: 'Die Erstellung einer Buchung ist fehlgeschlagen. Weitere Informationen erhalten Sie an der Rezeption.',
            finish: 'Zurück zum Startbildschirm',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Zahlung derzeit nicht möglich',
                body: 'Die Zahlung kann derzeit nicht gestartet werden. Sie erhalten in Kürze eine E-Mail mit einem Zahlungslink.',
            },
        },
        popupResetWizard: {
            title: 'Hallo, sind Sie noch da?',
            description: 'Sie haben diese Spalte seit 5 Minuten nicht mehr benutzt. Wir werden Ihre Buchung in 30 Sekunden stornieren. Treffen Sie eine Wahl:',
            continue: 'Weiter zur Buchung',
            restart: 'Abbrechen, zum Startbildschirm',
            close: 'schließen',
        },
        popupErrorMessage: {
            title: 'Hoppla, da ist etwas schiefgelaufen',
            continue: 'Ich verstehe',
            close: 'schließen',
        },
        timeTable: {
            disabled: {
                title: 'Willkommen bei {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Geben Sie Ihre Reservierungsnummer ein',
            input: {
                label: 'Reservierungsnummer',
                placeholder: 'Z.b. 123456789',
            },
            check: 'Anmeldung',
            failed: {
                unknownReservationNumber: 'Es gibt keine Reservierung mit der eingegebenen Nummer',
                alreadyArrived: 'Diese Reservierung wurde bereits angemeldet',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Anrede',
        book__form_field_firstname: 'Vorname',
        book__form_field_infix: 'Zusatz',
        book__form_field_surname: 'Nachname',
        book__form_field_organisation: 'Organisation',
        book__form_field_email: 'E-Mail-Adresse',
        book__form_field_telephone: 'Telefonnummer',
        book__form_field_mobile: 'Handynummer',
        book__form_field_phone: 'Telefonnummer',
        book__form_field_country: 'Land',
        book__form_field_zipcode: 'Postleitzahl',
        book__form_field_house_number: 'Hausnummer',
        book__form_field_house_number_suffix: 'Zusatz',
        book__form_field_street: 'Straße',
        book__form_field_place: 'Ort',
        book__form_field_birthdate: 'Geburtsdatum',
        book__form_field_birthplace: 'Geburtsort',
        book__form_field_nationality: 'Nationalität',
        book__form_field_passport_number: 'Reisepassnummer',
        book__form_field_license_plate: 'Kennzeichen',
        book__form_field_license_plate2: 'Kennzeichen 2',
        book__tommy_salution_malefemale: 'Herr / Frau',
        book__tommy_salution_male: 'Herr',
        book__tommy_salution_female: 'Frau',
        book__tommy_salution_family: 'Familie',
        book__form_validation_error_required: '{field} muss ausgefüllt werden',
        book__form_validation_error_required_simple: 'Dieses Feld muss ausgefüllt werden',
        book__form_validation_error_required_email: 'Entschuldigung, die eingegebene E-Mail-Adresse ist ungültig',
        book__form_validation_error_required_birthdate: 'Entschuldigung, das eingegebene Geburtsdatum ist ungültig',
    },

    // French
    fr: {
        languages: {
            nl: 'Néerlandais',
            en: 'Anglais',
            de: 'Allemand',
            fr: 'Français',
            it: 'Italien',
            es: 'Espagnol',
            pt: 'Portugais',
        },
        days: {
            day1: 'lundi',
            day2: 'mardi',
            day3: 'mercredi',
            day4: 'jeudi',
            day5: 'vendredi',
            day6: 'samedi',
            day7: 'dimanche',
        },
        months: {
            month1: 'janvier',
            month2: 'février',
            month3: 'mars',
            month4: 'avril',
            month5: 'mai',
            month6: 'juin',
            month7: 'juillet',
            month8: 'août',
            month9: 'septembre',
            month10: 'octobre',
            month11: 'novembre',
            month12: 'décembre',
        },
        navigation: {
            next: 'Suivant',
            prev: 'Étape précédente',
            quit: 'Arrêter et recommencer',
            guide: 'Vous avez un problème ? Alors signalez-le à la réception ou appelez le {phone_number} lorsque la réception est fermée.',
            pagination: {
                next: 'Page suivante',
                prev: 'Page précédente',
            },
            reset: 'Retour à l\'écran d\'accueil',
        },
        flows: {
            book: 'Effectuer une nouvelle réservation',
            checkIn: 'Récupérer une réservation existante',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Reserver',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Confirmation de la réservation',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Réserver un emplacement de camping ou de camping-car',
            par1: 'Vous pouvez réserver un emplacement de camping ou de camping-car ici et vous enregistrer directement. Vous pouvez payer avec le service bancaire mobile ou plus tard à la réception.',
            par2: 'Vous trouverez des informations complètes sur nos emplacements de camping et de caravane à la réception ou sur le site {website_url}.',
            // Legacy: 'intro-booking'
            start: 'Commencer la réservation',
            // Legacy: 'intro-text-2'
            subtitle: 'Réserver un logement',
            par3: 'La réservation d\'un logement est possible uniquement à la réception pendant les heures d\'ouverture ou en ligne sur {website_url}.',
        },
        travelGroup: {
            title: 'Choisissez votre groupe de voyage',
        },
        stayDuration: {
            title: 'Durée du séjour',
            nights: 'Nombre de nuits',
            arrival: 'Date d\'arrivée',
            departure: 'Date de départ',
            availability: 'Disponible à l\'adresse suivante',
            checking: 'Vérification de la disponibilité en cours',
            available: 'Emplacements disponibles.',
            unavailable: 'Désolé, complet.<br/>Veuillez vous adresser à la réception pour connaître les possibilités.',
        },
        pickAccommodation: {
            title: 'Choisissez votre type d\'hébergement',
            until: 'bis',
        },
        pets: {
            title: 'Animaux',
            description: 'Les chiens sont les bienvenus. Ils doivent être tenus en laisse en tout temps sur le terrain et il est obligatoire de ramasser leurs déjections.',
            type: 'Animaux',
        },
        pickAccommodationObject: {
            title: 'Choisissez votre lieu',
            selected: 'Lieu sélectionné',
            selectedNone: 'Aucun lieu n\'a été sélectionné',
            noContent: 'Malheureusement, le dernier hébergement disponible vient d\'être réservé. Veuillez choisir un autre hébergement.',
        },
        extras: {
            title: 'Extras',
        },
        receipt: {
            title: 'Aperçu des réservations',
            stayCost: 'Frais d\'hébergement',
            stayTime: 'Durée du séjour {nights} nuits',
            arrival: 'Date d\'arrivée {date} après {heure}',
            departure: 'Date de départ {date} avant {heure}',
            calculating: 'Calcul du prix en cours',
            invalid: 'Cet hébergement ne peut malheureusement pas être réservé. Veuillez vous rendre à la réception pour plus d\'informations.',
        },
        personalDetails: {
            title: 'Données à caractère personnel',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement indisponible',
                body: 'L\'arrangement choisi n\'est pas disponible.',
            },
        },
        receiptConfirm: {
            title: 'Données de contrôle',
            total: 'Montant total',
            licensePlate: 'Numéro d\'immatriculation du véhicule',
            pinMessage: 'Le paiement peut être effectué directement via le terminal.',
        },
        pin: {
            title: 'Payer',
            description: {
                par1: 'En quelques secondes, vous pouvez effectuer votre paiement au terminal de paiement avec votre carte de débit.',
                par2: 'Vous disposez d\'environ 30 secondes pour effectuer le paiement. Vous n\'y parvenez pas?',
                par3: 'Nous vous envoyons toujours un lien de paiement par e-mail, de sorte que vous pouvez toujours effectuer le paiement.',
                extra: '',
            },
            amountDue: 'Montant dû {due}',
            retry: 'Cliquez ici pour relancer le paiement',
            failed: 'Malheureusement, le paiement n\'a pas abouti',
            paid: 'Vous recevrez une confirmation par e-mail',
        },
        thanks: {
            description1: `
                <h2>Réservation effectuée avec succès</h2>
                <p>La réservation est terminée et vous êtes enregistré à l'adresse <strong class="location">{accommodation_name}{location_name}</strong>. Vous recevrez une confirmation par e-mail dans quelques minutes.</p>
            `,
            description2: `
                <p>Effectuez le paiement avant le {payment_due_date} à la réception ou via votre application bancaire mobile.</p>
                <p>Vous recevrez une confirmation par e-mail avec un lien de paiement dans quelques minutes. Vous pouvez également effectuer le paiement à la réception.</p>
            `,
            description3: `<h1 class="xl">Vos vacances à {park_name} ont commencé !</h1>`,
            bookingFailed : 'La création d\'une réservation a échoué. Veuillez vous rendre à la réception pour plus d\'informations.',
            finish: 'Retour à l\'écran d\'accueil',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Paiement indisponible pour le moment',
                body: 'Le paiement ne peut pas être lancé pour le moment. Vous recevrez prochainement un e-mail avec un lien de paiement.',
            },
        },
        popupResetWizard: {
            title: 'Bonjour, vous êtes toujours là ?',
            description: 'Vous n\'avez pas utilisé cette rubrique depuis 5 minutes. Nous annulerons votre réservation dans 30 secondes. Faites un choix :',
            continue: 'Continuer avec les livres',
            restart: 'Abandonner, pour démarrer l\'écran',
            close: 'Fermer',
        },
        popupErrorMessage: {
            title: 'Oups, quelque chose s\'est mal passé',
            continue: 'Je comprends',
            close: 'Fermer',
        },
        timeTable: {
            disabled: {
                title: 'Bienvenue à {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Entrez votre numéro de réservation',
            input: {
                label: 'Numéro de réservation',
                placeholder: 'Par exemple : 123456789',
            },
            check: 'Inscription',
            failed: {
                unknownReservationNumber: 'Il n\'y a pas de réservation avec le numéro saisi',
                alreadyArrived: 'Cette réservation a déjà été enregistrée',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Civilité',
        book__form_field_firstname: 'Prénom',
        book__form_field_infix: 'Préfixe',
        book__form_field_surname: 'Nom',
        book__form_field_organisation: 'Organisation',
        book__form_field_email: 'Adresse e-mail',
        book__form_field_telephone: 'Numéro de téléphone',
        book__form_field_mobile: 'Numéro de portable',
        book__form_field_phone: 'Numéro de téléphone',
        book__form_field_country: 'Pays',
        book__form_field_zipcode: 'Code postal',
        book__form_field_house_number: 'Numéro de maison',
        book__form_field_house_number_suffix: 'Ajout',
        book__form_field_street: 'Rue',
        book__form_field_place: 'Lieu',
        book__form_field_birthdate: 'Date de naissance',
        book__form_field_birthplace: 'Lieu de naissance',
        book__form_field_nationality: 'Nationalité',
        book__form_field_passport_number: 'Numéro de passeport',
        book__form_field_license_plate: "Plaque d'immatriculation",
        book__form_field_license_plate2: "Plaque d'immatriculation 2",
        book__tommy_salution_malefemale: 'Monsieur / Madame',
        book__tommy_salution_male: 'Monsieur',
        book__tommy_salution_female: 'Mme',
        book__tommy_salution_family: 'Famille',
        book__form_validation_error_required: '{field} doit être rempli',
        book__form_validation_error_required_simple:'Ce champ doit être rempli',
        book__form_validation_error_required_email: 'Excusez, l\'adresse e-mail saisie est invalide',
        book__form_validation_error_required_birthdate: 'Excusez, la date de naissance saisie est invalide',
    },

    // Italian
    it: {
        languages: {
            nl: 'Olandese',
            en: 'Inglese',
            de: 'tedesco',
            fr: 'francese',
            it: 'Italiano',
            es: 'spagnolo',
            pt: 'Portoghese',
        },
        days: {
            day1: 'lunedì',
            day2: 'martedì',
            day3: 'mercoledì',
            day4: 'giovedì',
            day5: 'venerdì',
            day6: 'sabato',
            day7: 'domenica',
        },
        months: {
            month1: 'gennaio',
            month2: 'febbraio',
            month3: 'marzo',
            month4: 'aprile',
            month5: 'maggio',
            month6: 'giugno',
            month7: 'luglio',
            month8: 'agosto',
            month9: 'settembre',
            month10: 'ottobre',
            month11: 'novembre',
            month12: 'dicembre',
        },
        navigation: {
            next: 'Il prossimo',
            prev: 'Passo indietro',
            quit: 'Fermare e ricominciare',
            guide: 'Hai un problema? Allora segnalalo alla reception o chiama il {phone_number} quando la reception è chiusa.',
            pagination: {
                next: 'Pagina successiva',
                prev: 'Pagina precedente',
            },
            reset: 'Torna alla schermata iniziale',
        },
        flows: {
            book: 'Effettuare una nuova prenotazione',
            checkIn: 'Recuperare una prenotazione esistente',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Prenotare',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Conferma prenotazione',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Prenota un posto campeggio o camper',
            par1: 'Puoi prenotare un posto campeggio o camper qui e fare il check-in direttamente. Puoi pagare con mobile banking o in un secondo momento alla reception.',
            par2: 'Troverai informazioni dettagliate sui nostri posti campeggio e camper alla reception o controlla {website_url}',
            // Legacy: 'intro-booking'
            start: 'Inizia la prenotazione',
            // Legacy: 'intro-text-2'
            subtitle: 'Prenotare un alloggio',
            par3: 'La prenotazione di un alloggio è possibile solo presso la reception durante l\'orario di apertura o online su {website_url}.',
        },
        travelGroup: {
            title: 'Scegli il tuo gruppo di viaggio',
        },
        stayDuration: {
            title: 'Durata del soggiorno',
            nights: 'Numero di notti',
            arrival: 'Data di arrivo',
            departure: 'Date de départ',
            availability: 'Disponibile a',
            checking: 'Verifica disponibilità in corso',
            available: 'Disponibilità sufficiente.',
            unavailable: 'Purtroppo, al completo.<br/>Chiedi alla receptione per le possibilità.',
        },
        pickAccommodation: {
            title: 'Scegli il tuo alloggio',
            until: 'fino a',
        },
        pets: {
            title: 'Animali domestici',
            description: 'I cani sono i benvenuti. Devono essere sempre tenuti al guinzaglio all\'interno del nostro terreno e vige ovunque l\'obbligo di raccogliere i bisogni.',
            type: 'Animali domestici',
        },
        pickAccommodationObject: {
            title: 'Scegli la tua posizione',
            selected: 'Posizione selezionata',
            selectedNone: 'Non è stata selezionata alcuna posizione',
            noContent: 'Purtroppo l\'ultima sistemazione disponibile è stata appena prenotata, ti preghiamo di scegliere un\'altra sistemazione.',
        },
        extras: {
            title: 'Extra',
        },
        receipt: {
            title: 'Panoramica delle prenotazioni',
            stayCost: 'Costi di soggiorno',
            stayTime: 'Durata del soggiorno {nights} notti',
            arrival: 'Data di arrivo {date} dopo le {time}',
            departure: 'Data di partenza {date} prima delle {time}',
            calculating: 'Calcolo del prezzo in corso',
            invalid: 'Purtroppo questa sistemazione non può essere prenotata, recati alla reception per ulteriori informazioni.',
        },
        personalDetails: {
            title: 'Dati personali',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement non disponibile',
                body: 'L\'arrangement selezionato non è disponibile.',
            },
        },
        receiptConfirm: {
            title: 'Controlla i tuoi dati',
            total: 'Importo totale',
            licensePlate: 'Targa del veicolo',
            pinMessage: 'Il pagamento può essere effettuato direttamente tramite il pinterminale',
        },
        pin: {
            title: 'Pagare',
            description: {
                par1: 'In pochi secondi puoi effettuare il pagamento al terminale POS con la tua carta di debito.',
                par2: 'Hai circa 30 secondi per completare il pagamento. Se non riesci a farlo?',
                par3: 'Ti inviamo comunque un link di pagamento via e-mail, in modo che tu possa effettuare il pagamento.',
                extra: '',
            },
            amountDue: 'Importo dovuto {due}',
            retry: 'Clicca qui per ricominciare il pagamento',
            failed: 'Purtroppo il pagamento non è andato a buon fine',
            paid: 'Riceverai una conferma via e-mail',
        },
        thanks: {
            description1: `
                <h2>Prenotazione completata con successo</h2>
                <p>La prenotazione è stata completata e sei stato registrato presso la struttura <strong class="location">{accommodation_name}{location_name}</strong>. Riceverai una conferma via e-mail entro pochi minuti.</p>
            `,
            description2: `
                <p>Paga entro il {payment_due_date} alla reception o tramite mobile banking.</p>
                <p>Riceverai una conferma via e-mail con il link per il pagamento entro pochi minuti. Puoi anche pagare alla reception.</p>
            `,
            description3: `<h1 class="xl">La tua vacanza al {park_name} è iniziata!</h1>`,
            bookingFailed: 'La creazione della prenotazione non è andata a buon fine. Rivolgiti alla reception per ulteriori informazioni.',
            finish: 'Torna alla schermata iniziale',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Pagamento non disponibile al momento',
                body: 'Al momento non è possibile avviare il pagamento. Riceverai a breve un\'e-mail con un link per il pagamento.',
            },
        },
        popupResetWizard: {
            title: 'Ciao, ci sei ancora?',
            description: 'Non hai utilizzato questo terminale per 5 minuti. Annulleremo la tua prenotazione tra 30 secondi. Fai una scelta:',
            continue: 'Continua con la prenotazione',
            restart: 'Annulla, torna alla schermata iniziale',
            close: 'Chiudere',
        },
        popupErrorMessage: {
            title: 'Ops, qualcosa è andato storto',
            continue: 'Capisco',
            close: 'Chiudere',
        },
        timeTable: {
            disabled: {
                title: 'Benvenuti a {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Inserisci il tuo numero di prenotazione',
            input: {
                label: 'Numero di prenotazione',
                placeholder: 'Esempio: 123456789',
            },
            check: 'Iscriviti',
            failed: {
                unknownReservationNumber: 'Non esiste alcuna prenotazione con il numero inserito',
                alreadyArrived: 'Questa prenotazione è già stata registrata',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Saluto',
        book__form_field_firstname: 'Nome',
        book__form_field_infix: 'Inserimento',
        book__form_field_surname: 'Cognome',
        book__form_field_organisation: 'Organizzazione',
        book__form_field_email: 'Indirizzo e-mail',
        book__form_field_telephone: 'Numero di telefono',
        book__form_field_mobile: 'Numero di cellulare',
        book__form_field_phone: 'Numero di telefono',
        book__form_field_country: 'Paese',
        book__form_field_zipcode: 'Codice postale',
        book__form_field_house_number: 'Numero civico',
        book__form_field_house_number_suffix: 'Suffisso',
        book__form_field_street: 'Via',
        book__form_field_place: 'Città',
        book__form_field_birthdate: 'Data di nascita',
        book__form_field_birthplace: 'Luogo di nascita',
        book__form_field_nationality: 'Nazionalità',
        book__form_field_passport_number: 'Numero di passaporto',
        book__form_field_license_plate: 'Targa',
        book__form_field_license_plate2: 'Targa 2',
        book__tommy_salution_malefemale: 'Signore / Signora',
        book__tommy_salution_male: 'Signore',
        book__tommy_salution_female: 'Signora',
        book__tommy_salution_family: 'Famiglia',
        book__form_validation_error_required: 'Il campo {field} deve essere compilato',
        book__form_validation_error_required_simple: 'Questo campo deve essere compilato',
        book__form_validation_error_required_email: 'Spiacenti, l\'indirizzo e-mail inserito non è valido',
        book__form_validation_error_required_birthdate: 'Spiacenti, la data di nascita inserita non è valida',
    },

    // Spanish
    es: {
        languages: {
            nl: 'Holandés',
            en: 'Inglés',
            de: 'Alemán',
            fr: 'Francés',
            it: 'Italiano',
            es: 'Español',
            pt: 'Portugués',
        },
        days: {
            day1: 'lunes',
            day2: 'martes',
            day3: 'miércoles',
            day4: 'jueves',
            day5: 'viernes',
            day6: 'sábado',
            day7: 'domingo',
        },
        months: {
            month1: 'enero',
            month2: 'febrero',
            month3: 'marzo',
            month4: 'abril',
            month5: 'mayo',
            month6: 'junio',
            month7: 'julio',
            month8: 'agosto',
            month9: 'septiembre',
            month10: 'octubre',
            month11: 'noviembre',
            month12: 'diciembre',
        },
        navigation: {
            next: 'Próximo',
            prev: 'Paso atrás',
            quit: 'Detener y comenzar de nuevo',
            guide: '¿Tienes un problema? Entonces repórtalo a recepción o llama al {phone_number} cuando recepción esté cerrada.',
            pagination: {
                next: 'Página siguiente',
                prev: 'Página anterior',
            },
            reset: 'Volver a la pantalla de inicio',
        },
        flows: {
            book: 'Hacer una nueva reserva',
            checkIn: 'Recuperar una reserva existente',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Reservar',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Confirmar reserva',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Reserve un lugar de camping o de autocaravana',
            par1: 'Puede reservar un lugar de camping o de autocaravana aquí y registrarse directamente. Puede pagar con banca móvil o más tarde en recepción.',
            par2: 'Encontrará información detallada sobre nuestros lugares de camping y de autocaravana en recepción o consulte {website_url}',
            // Legacy: 'intro-booking'
            start: 'Iniciar reserva',
            // Legacy: 'intro-text-2'
            subtitle: 'Reservar alojamiento',
            par3: 'La reserva de alojamiento solo es posible en recepción durante el horario de apertura o en línea en {website_url}.',
        },
        travelGroup: {
            title: 'Elige tu grupo de viaje',
        },
        stayDuration: {
            title: 'Duración de la estancia',
            nights: 'Número de noches',
            arrival: 'Fecha de llegada',
            departure: 'Fecha de salida',
            availability: 'Disponible en',
            checking: 'Comprobando disponibilidad',
            available: 'Plazas disponibles.',
            unavailable: 'Lo sentimos, completo.<br/>Pregunta en la receptie por las opciones disponibles.',
        },
        pickAccommodation: {
            title: 'Elige tu alojamiento',
            until: 'hasta',
        },
        pets: {
            title: 'Animales domésticos',
            description: 'Los perros son bienvenidos. Deben ir siempre con correa dentro de nuestras instalaciones y es obligatorio recoger sus necesidades.',
            type: 'Animales domésticos',
        },
        pickAccommodationObject: {
            title: 'Elige tu ubicación',
            selected: 'Ubicación seleccionada',
            selectedNone: 'No se ha seleccionado ninguna ubicación',
            noContent: 'Lamentablemente, el último alojamiento disponible acaba de ser reservado. Por favor, elija otro alojamiento.',
        },
        extras: {
            title: 'Extras',
        },
        receipt: {
            title: 'Resumen de reservas',
            stayCost: 'Costos de alojamiento',
            stayTime: 'Duración de la estancia {nights} noches',
            arrival: 'Fecha de llegada {date} después de las {time}',
            departure: 'Fecha de salida {date} antes de las {time}',
            calculating: 'Calculando el precio',
            invalid: 'Lamentablemente, este alojamiento no se puede reservar. Diríjase al mostrador para obtener más información.',
        },
        personalDetails: {
            title: 'Datos personales',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement no disponible',
                body: 'El arrangement seleccionado no está disponible.',
            },
        },
        receiptConfirm: {
            title: 'Compruebe sus datos',
            total: 'Cantidad total',
            licensePlate: 'Matrícula del vehículo',
            pinMessage: 'El pago puede efectuarse directamente a través del pinterminal',
        },
        pin: {
            title: 'Pagar',
            description: {
                par1: 'En unos segundos puede realizar el pago en el terminal POS con su tarjeta de débito.',
                par2: 'Tiene aproximadamente 30 segundos para completar el pago. ¿No lo consigue?',
                par3: 'Le enviamos un enlace de pago por correo electrónico, para que pueda realizar el pago.',
                extra: '',
            },
            amountDue: 'Importe pendiente {due}',
            retry: 'Haga clic aquí para reiniciar el pago',
            failed: 'Desafortunadamente el pago no fue exitoso',
            paid: 'Recibirá una confirmación por correo electrónico',
        },
        thanks: {
            description1: `
                <h2>Reserva completada con éxito</h2>
                <p>La reserva se ha completado y ya está registrado en la ubicación <strong class="location">{accommodation_name}{location_name}</strong>. En unos minutos recibirá una confirmación por correo electrónico.</p>
            `,
            description2: `
                <p>Paga antes del {payment_due_date} en recepción o mediante banca móvil.</p>
                <p>En unos minutos recibirás una confirmación por correo electrónico con un enlace de pago. También puedes pagar en recepción.</p>
            `,
            description3: `<h1 class="xl">¡Tus vacaciones en {park_name} han comenzado!</h1>`,
            bookingFailed: 'Se ha producido un error al crear la reserva. Diríjase a recepción para obtener más información.',
            finish: 'Volver a la pantalla de inicio',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Pago no disponible en este momento',
                body: 'En este momento no se puede iniciar el pago. En breve recibirá un correo electrónico con un enlace de pago.',
            },
        },
        popupResetWizard: {
            title: 'Hola, ¿sigues ahí?',
            description: 'No has utilizado este terminal durante 5 minutos. Cancelaremos tu reserva en 30 segundos. Haz una elección:',
            continue: 'Continuar con la reserva',
            restart: 'Cancelar, volver a la pantalla de inicio',
            close: 'Cerrar',
        },
        popupErrorMessage: {
            title: 'Vaya, algo ha salido mal',
            continue: 'Lo entiendo',
            close: 'Cerrar',
        },
        timeTable: {
            disabled: {
                title: 'Bienvenido a {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Introduzca su número de reserva',
            input: {
                label: 'Por ejemplo: 123456789',
                placeholder: 'Esempio: 123456789',
            },
            check: 'Inscribirse',
            failed: {
                unknownReservationNumber: 'No existe ninguna reserva con el número introducido',
                alreadyArrived: 'Esta reserva ya ha sido registrada',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Saludo',
        book__form_field_firstname: 'Nombre',
        book__form_field_infix: 'Infijo',
        book__form_field_surname: 'Apellido',
        book__form_field_organisation: 'Organización',
        book__form_field_email: 'Dirección de correo electrónico',
        book__form_field_telephone: 'Número de teléfono',
        book__form_field_mobile: 'Número de móvil',
        book__form_field_phone: 'Número de teléfono',
        book__form_field_country: 'País',
        book__form_field_zipcode: 'Código postal',
        book__form_field_house_number: 'Número de casa',
        book__form_field_house_number_suffix: 'Sufijo',
        book__form_field_street: 'Calle',
        book__form_field_place: 'Localidad',
        book__form_field_birthdate: 'Fecha de nacimiento',
        book__form_field_birthplace: 'Lugar de nacimiento',
        book__form_field_nationality: 'Nacionalidad',
        book__form_field_passport_number: 'Número de pasaporte',
        book__form_field_license_plate: 'Matrícula',
        book__form_field_license_plate2: 'Matrícula 2',
        book__tommy_salution_malefemale: 'Señor / Señora',
        book__tommy_salution_male: 'Señor',
        book__tommy_salution_female: 'Señora',
        book__tommy_salution_family: 'Familia',
        book__form_validation_error_required: '{field} debe estar rellenado',
        book__form_validation_error_required_simple: 'Este campo debe estar rellenado',
        book__form_validation_error_required_email: 'Lo sentimos, la dirección de correo electrónico introducida no es válida',
        book__form_validation_error_required_birthdate: 'Lo sentimos, la fecha de nacimiento introducida no es válida',
    },

    // Portuguese
    pt: {
        languages: {
            nl: 'Neerlandês',
            en: 'Inglês',
            de: 'Alemão',
            fr: 'Francês',
            it: 'Italiano',
            es: 'Espanhol',
            pt: 'Português',
        },
        days: {
            day1: 'segunda-feira',
            day2: 'terça-feira',
            day3: 'quarta-feira',
            day4: 'quinta-feira',
            day5: 'sexta-feira',
            day6: 'sábado',
            day7: 'domingo',
        },
        months: {
            month1: 'janeiro',
            month2: 'fevereiro',
            month3: 'março',
            month4: 'abril',
            month5: 'maio',
            month6: 'junho',
            month7: 'julho',
            month8: 'agosto',
            month9: 'setembro',
            month10: 'outubro',
            month11: 'novembro',
            month12: 'dezembro',
        },
        navigation: {
            next: 'Próximo',
            prev: 'Passo atrás',
            quit: 'Parar e começar de novo',
            guide: 'Tem um problema? Então reporte-o à receção ou ligue para {phone_number} quando a receção estiver fechada.',
            pagination: {
                next: 'Próxima página',
                prev: 'Página anterior',
            },
            reset: 'Voltar ao início',
        },
        flows: {
            book: 'Efetuar nova reserva',
            checkIn: 'Recuperar reserva existente',
        },
        loading: 'De zuil is aan het laden...',
        title: 'Reservar',
        book: {
            start: {
                nl: 'Boek een kampeerplaats',
                en: 'Book a camping pitch',
                de: 'Buchen Sie einen Stellplatz',
                fr: 'Réserver un emplacement de camping',
                it: 'Prenota una piazzola',
                es: 'Reservar una parcela',
                pt: 'Reservar um parque de campismo',
            },
            new: {
                nl: 'Nieuwe reservering plaatsen',
                en: 'Make a new reservation',
                de: 'Neue Reservierung vornehmen',
                fr: 'Faire une nouvelle réservation',
                it: 'Effettua una nuova prenotazione',
                es: 'Hacer una nueva reserva',
                pt: 'Fazer uma nova reserva',
            },
            existing: {
                nl: 'Bestaande reservering ophalen',
                en: 'Make a new reservation',
                de: 'Bestehende Reservierung abrufen',
                fr: 'Récupérer une réservation existante',
                it: 'Recupera una prenotazione esistente',
                es: 'Recuperar reserva existente',
                pt: 'Recuperar reserva existente',
            },
            confirm: 'Confirmar reserva',
        },
        intro: {
            // Legacy: 'intro-text-1'
            title: 'Reserve um lugar de acampamento ou de autocaravana',
            par1: 'Pode reservar um lugar de acampamento ou de autocaravana aqui e fazer o check-in diretamente. Pode pagar com mobile banking ou mais tarde na receção.',
            par2: 'Encontrará informações detalhadas sobre os nossos lugares de acampamento e de autocaravana na receção ou verifique {website_url}',
            // Legacy: 'intro-booking'
            start: 'Iniciar reserva',
            // Legacy: 'intro-text-2'
            subtitle: 'Reservar alojamento',
            par3: 'A reserva de alojamento só é possível na receção durante o horário de funcionamento ou online em {website_url}.',
        },
        travelGroup: {
            title: 'Escolha o seu grupo de viagem',
        },
        stayDuration: {
            title: 'Duração da estadia',
            nights: 'Número de noites',
            arrival: 'Data de chegada',
            departure: 'Data de partida',
            availability: 'Disponível em',
            checking: 'A verificar a disponibilidade',
            available: 'Lugares disponíveis.',
            unavailable: 'Desculpe, está cheio. <br/>Pergunte na receção pelas opções disponíveis.',
        },
        pickAccommodation: {
            title: 'Escolha o seu alojamento',
            until: 'até',
        },
        pets: {
            title: 'Animales domésticos',
            description: 'Os cães são bem-vindos. Devem ser mantidos sempre com trela no interior das nossas instalações e é obrigatório recolher os seus restos mortais.',
            type: 'Animales domésticos',
        },
        pickAccommodationObject: {
            title: 'Escolha a sua localização',
            selected: 'Localização selecionada',
            selectedNone: 'Não foi selecionado nenhum local',
            noContent: 'Infelizmente, a última acomodação disponível acaba de ser reservada. Por favor, escolha outra acomodação.',
        },
        extras: {
            title: 'Extras',
        },
        receipt: {
            title: 'Resumo das reservas',
            stayCost: 'Custos de alojamento',
            stayTime: 'Duração da estadia {nights} noites',
            arrival: 'Data de chegada {date} após {time}',
            departure: 'Data de partida {date} antes de {time}',
            calculating: 'A calcular o preço',
            invalid: 'Infelizmente, este alojamento não pode ser reservado. Dirija-se ao balcão para obter mais informações.',
        },
        personalDetails: {
            title: 'Dados pessoais',
        },
        arrangement: {
            unavailable: {
                title: 'Arrangement indisponível',
                body: 'O arrangement selecionado não está disponível.',
            },
        },
        receiptConfirm: {
            title: 'Compruebe sus datos',
            total: 'Montante total',
            licensePlate: 'Matrícula do veículo',
            pinMessage: 'O pagamento pode ser efectuado diretamente através do pinterminal',
        },
        pin: {
            title: 'Pagar',
            description: {
                par1: 'Em poucos segundos, pode efetuar o pagamento no terminal POS com o seu cartão de débito.',
                par2: 'Tem cerca de 30 segundos para efetuar o pagamento. Não está a conseguir?',
                par3: 'Enviamos-lhe ainda um link de pagamento por e-mail, para que possa efetuar o pagamento.',
                extra: '',
            },
            amountDue: 'Montante em aberto {due}',
            retry: 'Clique aqui para reiniciar o pagamento',
            failed: 'Infelizmente o pagamento não foi bem-sucedido',
            paid: 'Receberá uma confirmação por e-mail',
        },
        thanks: {
            description1: `
                <h2>Reserva concluída com sucesso</h2>
                <p>A reserva foi concluída e o check-in foi feito no local <strong class="location">{accommodation_name}{location_name}</strong>. Receberá uma confirmação por e-mail dentro de alguns minutos.</p>
            `,
            description2: `
                <p>Pague até {payment_due_date} na receção ou através de banca móvel.</p>
                <p>Receberá uma confirmação por e-mail com um link de pagamento dentro de alguns minutos. Também pode pagar na receção.</p>
            `,
            description3: `As suas férias no {park_name} começaram!</h1>`,
            bookingFailed: 'A criação da reserva falhou. Dirija-se à receção para obter mais informações.',
            finish: 'Voltar ao início',
        },
        idealCheckout: {
            paymentUnavailable: {
                title: 'Pagamento indisponível neste momento',
                body: 'Neste momento não é possível iniciar o pagamento. Em breve receberá um e-mail com um link de pagamento.',
            },
        },
        popupResetWizard: {
            title: 'Olá, ainda estás aí?',
            description: 'Não usaste este terminal durante 5 minutos. Vamos cancelar a tua reserva em 30 segundos. Faz uma escolha:',
            continue: 'Continuar com a reserva',
            restart: 'Cancelar, voltar ao ecrã inicial',
            close: 'Fechar',
        },
        popupErrorMessage: {
            title: 'Oops, algo deu errado',
            continue: 'Entendi',
            close: 'Fechar',
        },
        timeTable: {
            disabled: {
                title: 'Bem-vindo ao {park_name}',
                message: `<p>Nice to have you here! Our park is open from 1 November to 1 April for self-sufficient motorhomes only. Caravans and tents are not allowed during this period.</p><p>Please note that the reception, sanitary facilities, shop and restaurant are closed.</p><p>All camper pitches have electricity, and our camper service stations for water, grey water drainage and toilet cleaning are open.</p><p>You can check-in after 12.00 until 22.30 at the latest. Payment can be made by debit or credit card (Visa/Mastercard). Follow the steps on the screen to check in.</p><p>Have fun during your stay!</p>`,
                retry: 'Retry',
            },
        },
        reservationNumber: {
            title: 'Insira o número da sua reserva',
            input: {
                label: 'Número de reserva',
                placeholder: 'Por exemplo: 123456789',
            },
            check: 'Inscrever-se',
            failed: {
                unknownReservationNumber: 'Não existe nenhuma reserva com o número introduzido',
                alreadyArrived: 'Esta reserva já foi registada',
            },
        },
        // Re-use from main booking widgets
        book__form_field_salutation: 'Saudações',
        book__form_field_firstname: 'Nome próprio',
        book__form_field_infix: 'Infix',
        book__form_field_surname: 'Apelido',
        book__form_field_organisation: 'Organização',
        book__form_field_email: 'Endereço de e-mail',
        book__form_field_telephone: 'Número de telefone',
        book__form_field_mobile: 'Número de telemóvel',
        book__form_field_phone: 'Número de telefone',
        book__form_field_country: 'País',
        book__form_field_zipcode: 'Código postal',
        book__form_field_house_number: 'Número da casa',
        book__form_field_house_number_suffix: 'Sufixo',
        book__form_field_street: 'Rua',
        book__form_field_place: 'Localidade',
        book__form_field_birthdate: 'Data de nascimento',
        book__form_field_birthplace: 'Local de nascimento',
        book__form_field_nationality: 'Nacionalidade',
        book__form_field_passport_number: 'Número de passaporte',
        book__form_field_license_plate: 'Matrícula',
        book__form_field_license_plate2: 'Matrícula 2',
        book__tommy_salution_malefemale: 'Senhor / Senhora',
        book__tommy_salution_male: 'Senhor',
        book__tommy_salution_female: 'Senhora',
        book__tommy_salution_family: 'Família',
        book__form_validation_error_required: '{field} deve ser preenchido',
        book__form_validation_error_required_simple: 'Este campo deve ser preenchido',
        book__form_validation_error_required_email: 'Desculpe, o endereço de e-mail introduzido é inválido',
        book__form_validation_error_required_birthdate: 'Desculpe, a data de nascimento introduzida é inválida',
    },
};
